'use client';

import { setIconSpriteHref } from '@chemist4u/newt-components';
import { ICON_SPRITE_URL } from '@lib/icons/sprite-config';

/**
 * Points the design system's `<Icon>` at the external sprite route so it
 * renders `<use href="/icons/sprite.svg#name">` instead of a same-document
 * `#name` reference. The browser then resolves/fetches the sprite natively
 * (HTTP-cached per the route's headers) whenever a `<use>` needs it — no
 * client-side fetch-then-inject step, and no flash of blank icons.
 *
 * This is a module-scope call, not a `useEffect`: it must run before the
 * first render of any `<Icon>` in this module graph, and `useEffect` runs
 * after render/paint. `setIconSpriteHref` is a plain module-level variable
 * inside `@chemist4u/newt-components`, and Next.js gives Server Components
 * (RSC) and Client Components (SSR + browser) separate instances of that
 * module — so this file's call only covers the Client Component side. The
 * matching call for Server Components lives in `src/app/layout.tsx`, at
 * module scope, with the same value. Both must stay in sync.
 *
 * Renders nothing: it exists purely so this module is included in the
 * client bundle and evaluated (for its side effect) before hydration.
 */
setIconSpriteHref(ICON_SPRITE_URL);

export default function IconSpriteLoader() {
  return null;
}
